import { Fragment } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import Logo from '../images/logo.png'
import { Link, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { logout } from '../slice/userSlice';
import { AiOutlineShoppingCart } from "react-icons/ai";
import { VscSymbolColor } from "react-icons/vsc";
import cart from '../data/cart.json'
import { IoSettingsSharp } from "react-icons/io5";
import { CgProfile, CgLogOut } from "react-icons/cg";


const navigation = [
  { name: 'سەرەکی', href: '/home', current: true },
  { name: 'پێشبینیکردن', href: '/peshbinikrdn', current: false },
  { name: 'یاریەکان', href: '/games', current: false },
  { name: 'خاڵەکان', href: '/nmra', current: false },
  { name: 'کاڵاوەرزشیەکان', href: '/sport', current: false },

]


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navbar() {
  const location = useLocation();
  const user = useSelector((state) => state.user)
  // const username = localStorage.getItem('username');
  const dispatch = useDispatch();

  
  return (
    

    <Disclosure as="nav" className="text-xl p-4 bg-yakam">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto  px-2 sm:px-6 lg:px-8">
            <div className="relative flex flex-row-reverse items-center  h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex  items-center justify-center p-2 rounded-md text-chwaram hover:text-chwaram hover:bg-penjam focus:outline-none focus:ring-2 focus:ring-inset focus:ring-chwaram">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex flex-row-reverse items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <Link to='/home'>


                    <img
                      className="block lg:hidden h-16 w-16"
                      src={Logo}
                      alt="Peshbini"
                    />
                    <img
                      className="hidden lg:block h-16 w-16"
                      src={Logo}
                      alt="Peshbini"
                    />
                  </Link>
                </div>
                <div className="hidden sm:block  my-auto sm:ml-6">
                  <div className="flex space-x-4">
                    {navigation.reverse().map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={classNames(
                          location.pathname === item.href ? ' font-bold text-lg border-b-2 border-b-chwaram text-seyam' : ' font-bold  text-lg text-chwaram hover:text-seyam hover:border-b-2 hover:border-b-chwaram',
                          ' text-[13px]  lg:text-lg  font-bold '
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">


                {/* Profile dropdown */}

                {user.isAuthed ? (
                  <>
                    <div className='flex p-1 items-center '>
                      <Link to='/cart' >
                        <AiOutlineShoppingCart className='w-10 h-8 text-chwaram hover:text-seyam' />
                      </Link>
                      <Link to='/settings' className='hidden md:block' >
                        <VscSymbolColor className='w-10 h-8 text-chwaram hover:text-seyam' />
                      </Link>
                      {cart.length > 0 ?
                        (
                          <div className='bg-penjam w-4 h-4 text-chwaram text-sm absolute -mt-6 ml-6 rounded-full  text-center'>
                            {cart.length}
                          </div>
                        )
                        :
                        (
                          null
                        )
                      }

                    </div>
                    <Menu as="div" className="ml-3 z-10 relative">
                      <div>
                        <Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                          <span className="sr-only">Open user menu</span>
                          <img
                            className="h-14 w-14 rounded-full"
                            src={user.userImage}
                            alt=""
                          /><span class="top-10 left-10 absolute  w-3.5 h-3.5 bg-green-500 border-2 border-white  rounded-full"></span>
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-10"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-10"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className=" absolute  text-right right-0 mt-2 w-fit  rounded-md shadow-lg py-1 bg-white backdrop-blur-xl bg-opacity-30 ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {user.userRole === 'admin' ?
                            (

                              <Menu.Item>
                                {({ active }) => (
                                  <Link
                                    to="/profile"
                                    className={classNames(active ? 'text-seyam' : '', 'flex items-center flex-row-reverse px-4 py-2 text-base  text-shasham hover:text-yakam')}
                                  >

                                    &nbsp;پڕۆفایل<CgProfile className='p-px' />
                                  </Link>
                                )}
                              </Menu.Item>
                            )
                            :
                            (
                              null
                            )
                          }
                          <Menu.Item>
                            {({ active }) => (
                              <Link

                                to="/settings"
                                className={classNames(active ? 'text-seyam' : '', 'items-center flex-row-reverse px-4 py-2 flex text-base  text-shasham hover:text-yakam')}
                              >
                                &nbsp;ڕێکخستنەکان<IoSettingsSharp className='p-px' />

                              </Link>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <Link
                                to='/'
                                onClick={() => dispatch(logout())}
                                className={classNames(active ? 'text-seyam' : '', 'flex items-center flex-row-reverse px-4 py-2 text-base  text-shasham hover:text-yakam')}
                              >

                                &nbsp;چونەدەرەوە<CgLogOut className='p-px' />
                              </Link>
                            )}
                          </Menu.Item>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </>
                ) : (
                  <Link to="/login" className="shadow-sm shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-full overflow-hidden text-sm font-medium text-chwaram rounded-lg group bg-gradient-to-br from-penjam to-chwaram group-hover:from-penjam group-hover:to-chwaram hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                    <span className="shadow-sm shadow-penjam relative w-full px-5 py-2.5 transition-all ease-in duration-75 bg-yakam  rounded-md group-hover:bg-opacity-0">
                      چوونەژوورەوە
                    </span>
                  </Link>
                )}


              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.reverse().map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as={Link}
                  to={item.href}
                  className={classNames(
                    location.pathname === item.href ? 'bg-shasham text-seyam' : 'text-chwaram hover:bg-shasham hover:text-seyam',
                    'block px-3 py-2 rounded-md text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
    
  )
}
